import React from 'react';

const Loader = () => (
  <div className="loading-cards">
    <div className="loading-cards__card" />
    <div className="loading-cards__card" />
    <div className="loading-cards__card" />
  </div>
);

export default Loader;
